import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
    mode: 'hash',
    routes: [
        {
            path: '/index',
            component: () => import('@/views/index'),
            meta: {keepAlive: true}
        },
        {
            path: '/login',
            component: () => import('@/views/login'),
            meta: {public: true}
        },
        {
            path: '/register',
            component: () => import('@/views/register'),
            meta: {public: true}
        },
        {
            path: '/main',
            component: () => import('@/views/main')
        },
        // ==================== 1 级列表页（通电缓存） ====================
        {
            path: '/ruku',
            component: () => import('@/views/ruku/a1'),
            meta: {keepAlive: true}
        },
        {
            path: '/chuku',
            component: () => import('@/views/chuku/a1'),
            meta: {keepAlive: true}
        },
        {
            path: '/fanchang',
            component: () => import('@/views/fanchang/a1'),
            meta: {keepAlive: true}
        },
        {
            path: '/diaobo',
            component: () => import('@/views/diaobo/a1'),
            meta: {keepAlive: true}
        },
        {
            path: '/fanxiu',
            component: () => import('@/views/fanxiu/a1'),
            meta: {keepAlive: true}
        },
        {
            path: '/kucun',
            component: () => import('@/views/kucun/a1'),
            meta: {keepAlive: true}
        },
        // ==================== 2 级详情页（⚡ 核心修正：全部注入通电缓存） ====================
        {
            path: '/rukuDetail',
            component: () => import('@/views/ruku/b1'),
        },
        {
            path: '/chukuDetail',
            component: () => import('@/views/chuku/b1'),
        },
        {
            path: '/fanchangDetail',
            component: () => import('@/views/fanchang/b1'),
        },
        {
            path: '/diaoboDetail',
            component: () => import('@/views/diaobo/b1'),
        },
        {
            path: '/fanxiuDetail',
            component: () => import('@/views/fanxiu/b1'),
        },
        {
            path: '/kucunDetail',
            component: () => import('@/views/kucun/b1'),
            meta: {keepAlive: true} // ➔ 注入防御缓存
        },
        // ==================== 3 级流水/级联页（不需要缓存） ====================
        {
            path: '/kucunDetailDetail',
            component: () => import('@/views/kucun/c1')
        },
    ]
});

export default router;